
import { Vue } from "vue-class-component";
import { Prop } from "vue-property-decorator";
export default class Loading extends Vue {
  @Prop({ default: "", type: String }) alternativeText: string;
}
